const src = import.meta.ROLLUP_FILE_URL_0PgJxXqjw$KAl6PgZjQb5g;
export default {
  src,
  srcSet: src + " " + 4096 + "w",
  width: 4096,
  height: 2730,
};